import { useQuery } from "@tanstack/react-query";
import { SecurityAppInvestigationsSummary } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const fetchAIReport = (investigationId) => SecurityAppInvestigationsSummary.investigationReport(investigationId).then((report) => report == null ? void 0 : report.text);
const useAiReport = (investigationId, enabled) => {
  const { data, isLoading, isFetching, isSuccess, isFetched, isError, error } = useQuery({
    queryKey: ["investigation-ai-report", investigationId],
    queryFn: () => defaultOnError(
      fetchAIReport(investigationId),
      "Fetching AI Report failed with status",
      "Could not fetch AI Report"
    ),
    enabled
  });
  return {
    data,
    isLoading,
    isFetching,
    isSuccess,
    isFetched,
    isError,
    error
  };
};
export default useAiReport;
